import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGetNotice from "../../hooks/useGetNotice";
import theme from "../../theme";
import NoticeList from "./noticeList";
import Pagination from "@mui/material/Pagination";
import userStorage from "../../utils/userStorage";
import Spinner from "../../components/spinner";
import { AddMobileButton } from "../../assets/icons/icons";
import { Button } from "../../components/common/Button";
import { PageLayout } from "../../components/PageLayout";
import { useWindowSize } from "@reactuses/core";
import { Box, Fab } from "@mui/material";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const Notice: React.FC<{}> = () => {
  const { t } = useI18n();
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(() => {
    const currentPage = searchParams.get("page");
    return currentPage ? Number(currentPage) : 1;
  });
  const user = userStorage.get();
  const navigate = useNavigate();
  const { width } = useWindowSize();

  const { data, isLoading } = useGetNotice(page - 1);

  useEffect(() => {
    const currentPage = searchParams.get("page");
    setPage(currentPage ? Number(currentPage) : 1);
  }, [searchParams]);

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setSearchParams({ page: value.toString() });
  };

  const onClickAdminBtn = () => {
    navigate(`/notice-admin`);
  };

  return (
    <PageLayout
      bodyHeight="calc(100vh - 112px)"
      bodyMinHeight="1105px"
      withBreadcrumb
    >
      <Title>{t.notice.title}</Title>

      {/* 공지 목록 리스트 */}
      <NoticeWrapper>
        {isLoading && <Spinner />}
        {data &&
          data?.list.length > 0 &&
          data?.list.map((el) => (
            <NoticeList item={el} key={el.idx.toString()} />
          ))}
        {!isLoading && data && data.list.length === 0 && (
          <NoticeEmpty>{t.notice.noNotice}</NoticeEmpty>
        )}
      </NoticeWrapper>

      {/* 페이지네이션 */}
      {!isLoading && (
        <PaginationFooter>
          <Pagination
            count={data?.total_page}
            page={page}
            siblingCount={width <= md ? 1 : 3}
            onChange={handleChange}
            // size={width <= md ? "small" : "medium"}
          />
        </PaginationFooter>
      )}

      {/* 새공지 등록하기 버튼 - 접근 권한 있음 */}
      {user?.grade === 2 &&
        // 모바일 UI
        (width <= md ? (
          <Box
            sx={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              "& .MuiFab-root": {
                backgroundColor: theme.color.green_500,
                ":hover": {
                  backgroundColor: theme.color.green_600,
                },
              },
            }}
          >
            <Fab onClick={onClickAdminBtn}>
              <AddMobileButton />
            </Fab>
          </Box>
        ) : (
          // md ~
          <Box
            sx={{
              display: "flex",
              alignSelf: "flex-end",
            }}
          >
            <Button
              bgColor={theme.statusColor.MAIN}
              hoverColor={theme.statusColor.MAIN_HOVER}
              onClick={onClickAdminBtn}
              style={{
                width: "165px",
                height: "40px",
                position: "relative",
                paddingLeft: "30px",
              }}
            >
              {t.notice.register}
              <AddMobileButtonContainer>
                <AddMobileButton />
              </AddMobileButtonContainer>
            </Button>
          </Box>
        ))}
    </PageLayout>
  );
};

// 기존 버전
// const Notice: React.FC<{}> = () => {
//   const { pages } = useParams<{ pages: string }>();

//   const [page, setPage] = useState(pages ? Number(pages) - 1 : 0);
//   const user = userStorage.get();
//   const navigate = useNavigate();
//   const { width } = useWindowSize();

//   const { data, isLoading } = useGetNotice(
//     pages ? Number(pages) - 1 : page
//   );

//   useEffect(() => {
//     if (pages) {
//       setPage(Number(pages) - 1);
//       return;
//     }
//     if (!pages) {
//       setPage(0);
//     }
//   }, [pages]);

//   const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
//     setPage(value - 1);
//     navigate(`/notice/pages/${value}`);
//   };

//   const onClickAdminBtn = () => {
//     navigate(`/notice-admin`);
//   };

//   return (
//     <PageLayout
//       bodyHeight="calc(100vh - 112px)"
//       bodyMinHeight="1105px"
//       withBreadcrumb
//     >
//       <Title>공지사항</Title>

//       {/* 공지 목록 리스트 */}
//       <NoticeWrapper>
//         {isLoading && <Spinner />}
//         {data &&
//           data?.list.length > 0 &&
//           data?.list.map((el) => (
//             <NoticeList item={el} key={el.idx.toString()} />
//           ))}
//         {!isLoading && data && data.list.length === 0 && (
//           <NoticeEmpty>등록된 공지사항이 없습니다.</NoticeEmpty>
//         )}
//       </NoticeWrapper>

//       {/* 페이지네이션 */}
//       {!isLoading && (
//         <PaginationFooter>
//           <Pagination
//             count={data?.total_page}
//             page={page + 1}
//             siblingCount={width <= md ? 1 : 3}
//             onChange={handleChange}
//             // size={width <= md ? "small" : "medium"}
//           />
//         </PaginationFooter>
//       )}

//       {/* 새공지 등록하기 버튼 - 접근 권한 있음 */}
//       {user?.grade === 2 &&
//         // 모바일 UI
//         (width <= md ? (
//           <Box
//             sx={{
//               position: "fixed",
//               bottom: "20px",
//               right: "20px",
//               "& .MuiFab-root": {
//                 backgroundColor: theme.color.green_500,
//                 ":hover": {
//                   backgroundColor: theme.color.green_600,
//                 },
//               },
//             }}
//           >
//             <Fab onClick={onClickAdminBtn}>
//               <AddMobileButton />
//             </Fab>
//           </Box>
//         ) : (
//           // md ~
//           <Box
//             sx={{
//               display: "flex",
//               alignSelf: "flex-end",
//             }}
//           >
//             <Button
//               bgColor={theme.statusColor.MAIN}
//               hoverColor={theme.statusColor.MAIN_HOVER}
//               onClick={onClickAdminBtn}
//               style={{
//                 width: "165px",
//                 height: "40px",
//                 position: "relative",
//                 paddingLeft: "30px",
//               }}
//             >
//               {`공지사항 등록하기`}
//               <AddMobileButtonContainer>
//                 <AddMobileButton />
//               </AddMobileButtonContainer>
//             </Button>
//           </Box>
//         ))}
//     </PageLayout>
//   );
// };

const Title = styled.h1`
  font-weight: 700;
  font-size: 20px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  padding-bottom: 15px;
  border-bottom: ${`3px solid ${theme.color.neutral_200}`};
  margin-bottom: 20px;
  padding-left: 10px;

  @media (max-width: ${md}px) {
    font-size: 18px;
  }
`;

const NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;

  @media (max-width: ${md}px) {
    padding-bottom: 30px;
  }
`;

const AddMobileButtonContainer = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
`;

const PaginationFooter = styled.footer`
  display: flex;
  justify-content: center;
  position: relative;
  height: 40px;
  margin-top: 15px;
`;

const NoticeEmpty = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: ${theme.color.neutral_500};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${md}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export default Notice;
